<div class="onboarding-card">

  <!-- Skip tutto -->
  <button class="skip-all" (click)="skipAll()">Salta tutto →</button>

  <!-- Progress bar -->
  <div class="progress-bar">
    <div class="progress-fill" [style.width.%]="progress"></div>
  </div>
  <p class="step-label">Passo {{ step }} di {{ journey.length }}</p>
  <!-- Tutte le tappe, anche contratto e listino che arrivano dopo, in altre pagine -->
  <ol class="journey">
    <li *ngFor="let t of journey; let i = index" [class.done]="i + 1 < step" [class.current]="i + 1 === step">{{ t }}</li>
  </ol>

  <!-- ===== STEP 1 — Categoria ===== -->
  <div *ngIf="step === 1" class="step">
    <h1 class="step-title">Chi sei? <app-info-tooltip text="Personalizza alcuni testi dell'app in base al tuo lavoro (es. 'Prova' per trucco/parrucco, 'Sopralluogo' per altri servizi)."></app-info-tooltip></h1>
    <p class="step-desc">Seleziona la tua categoria professionale. Puoi cambiarla in qualsiasi momento dal profilo.</p>

    <div class="category-grid">
      <button
        *ngFor="let c of categories"
        class="category-btn"
        [class.selected]="hasCategory(c.value)"
        (click)="toggleCategory(c.value)"
      >
        {{ c.label }}
      </button>
    </div>
  </div>

  <!-- ===== STEP 2 — Dati studio ===== -->
  <div *ngIf="step === 2" class="step">
    <h1 class="step-title">Il tuo studio</h1>
    <p class="step-desc">Questi dati appaiono nell'intestazione del contratto PDF.</p>

    <div class="field-group">
      <div class="field">
        <label>Nome studio / attività</label>
        <input type="text" [(ngModel)]="business_name" placeholder="Es. Studio Bianchi" />
      </div>
      <div class="field">
        <label>Telefono <app-info-tooltip text="Il recapito dello studio mostrato nel contratto, non il tuo numero personale se preferisci tenerli separati."></app-info-tooltip></label>
        <app-phone-input [(ngModel)]="telephone" placeholder="333 000 0000"></app-phone-input>
      </div>
      <div class="field">
        <label>Email fatturazione</label>
        <input
          type="email"
          [(ngModel)]="email"
          (ngModelChange)="emailError = false"
          placeholder="studio@email.com"
          autocapitalize="off"
          [class.input-error]="emailError"
        />
        <span class="field-error" *ngIf="emailError">Inserisci un'email valida</span>
      </div>
      <div class="field">
        <label>P.IVA / C.F. <app-info-tooltip text="Facoltativo. Se non hai una Partita IVA puoi lasciare il campo vuoto o inserire il tuo Codice Fiscale."></app-info-tooltip></label>
        <input type="text" [(ngModel)]="piva" placeholder="IT00000000000" />
      </div>
      <div class="field">
        <label>Indirizzo</label>
        <input type="text" [(ngModel)]="address" placeholder="Via Roma 1, Milano" />
      </div>
    </div>
  </div>

  <!-- ===== STEP 3 — Firma ===== -->
  <div *ngIf="step === 3" class="step">
    <h1 class="step-title">La tua firma</h1>
    <p class="step-desc">Disegna la tua firma professionale, apparirà nel PDF del contratto.</p>

    <div class="signature-area">
      <app-signature-pad></app-signature-pad>
      <button type="button" class="btn-clear" (click)="clearSignature()">Cancella</button>
    </div>
  </div>

  <!-- Azioni -->
  <div class="step-actions">
    <div class="step-actions-main">
      <button class="btn-back" *ngIf="step > 1" (click)="back()" [disabled]="saving">← Indietro</button>
      <button class="btn-gold" (click)="next()" [disabled]="saving">
        {{ step < totalSteps ? 'Avanti' : 'Avanti: il contratto' }}
      </button>
    </div>
    <button class="skip-step" (click)="skipStep()">Salta questo step</button>
  </div>

</div>
